import fonts from '../assets/fonts';

export const text = {
    baseStyle: {
        w: '100%',
        hyphens: 'auto',
        overflowWrap: 'break-word',
        fontFamily: 'Montserrat',
    },
    variants: {
        titleXL: {
            ...fonts.titleXL,
        },
        titleL: {
            ...fonts.titleL,
        },
        titleM: {
            ...fonts.titleM,
        },
        titleCustomField: {
            ...fonts.titleCustomField,
        },
        subtitle: {
            ...fonts.subtitle,
        },
        text: {
            ...fonts.text,
        },
        normal: {
            ...fonts.normal,
        },
        button: {
            ...fonts.button,
        },
    },
};
